import { Injectable } from '@angular/core';
import { AccountService } from './account.service';
import { StorageService } from './storage.service';
import { TranslateService } from '../../shared/modules/translate/translate.service';
import { AuthGuardService } from './auth/auth-guard.service';
import { DocumentService } from './document.service';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class I18nDetectorService {
  private _language: string | null = null;
  isRTL = false;
  languageDetectedFrom: "PATH" | "USER" | "STORAGE" | "DEFAULT" | undefined;

  dir: string = 'ltr' as any;

  get language(): string {
    return this._language as string;
  }

  // languageChanged = new EventEmitter();
  constructor(
    private storage: StorageService,
    private translationService: TranslateService,
    private documentService: DocumentService,
    private authGuardService: AuthGuardService,
    private accountService: AccountService

  ) { }

  setLanguage() {
    this.detectLanguageFromCurrentPagePath();
    this.detectLanguageFromCurrentUser();
    this.detectLanguageFromCurrentSrotage();
    this.detectDefaultLanguage();

    this.detectDirection();

    this.translationService.setLanguage(this._language as string);

    this.injectFontsLinksInPage();

    this.updateCurrentUserLanguage();

    console.log(this.languageDetectedFrom);

  }

  /**
   * Detects the language from the current page path.
   * @returns true if language is detected from URL, false otherwise
   */
  detectLanguageFromCurrentPagePath() {
    const langFromUrl = this.documentService.location.pathname
      .split('/')
      .filter((c) => c)[0];
    switch (langFromUrl) {
      case 'en':
      case 'ar':
      case 'zh':
      case 'es':
      case 'hi':
      case 'bn':
      case 'pt':
      case 'ru':
      case 'fr':
      case 'ur':
        {
          this.languageDetectedFrom = "PATH";
          this.storage.i18n.value = langFromUrl;
          this._language = langFromUrl;
          return;
        }
      default:
        {
          return;
        }
    }
  }


  /**
   * Detect Language From User If Not Detectd Yet And Not Anoymous 
   * If Language Not Stored Yet I Will Load It From Server And Save It In Storage To Get From Storae In Next Time
   */
  async detectLanguageFromCurrentUser() {
    try {
      if (!this.languageDetectedFrom && this.authGuardService.isLoggedIn() && (this.storage.i18n.value != this.authGuardService.currentUser.languageCode)) {
        //Get From Server
        let loggedUserLanguage = (await this.accountService.getCurrentLanguage()).result
        this._language = loggedUserLanguage;
        this.storage.i18n.value = loggedUserLanguage;
        this.languageDetectedFrom = "USER";
      }
    } catch (error) {

    }
  }


  /**
   * Detect Language From Storage If Not Detectd Yet
   */
  detectLanguageFromCurrentSrotage() {
    if (!this.languageDetectedFrom && this.storage.i18n.value) {
      this._language = this.storage.i18n.value;
      this.languageDetectedFrom = "STORAGE";
    }
  }

  detectDefaultLanguage() {
    if (!this.languageDetectedFrom) {
      this._language = "en";
      this.languageDetectedFrom = "DEFAULT";
    }
  }

  injectFontsLinksInPage() {
    if (this.isRTL) {
      this.documentService.injectARFont();
    } else {
      this.documentService.injectENFont();
    }
  }

  detectDirection() {
    this.dir = this._language == 'ar' || this._language == 'ur' ? 'rtl' : 'ltr';
    this.isRTL = this.dir == 'rtl';
    this.documentService.bindCulrutrInfo(this.dir as string, this.language)
  }

  /**
   * Update Current User Token If Diffrent
   */
  async updateCurrentUserLanguage() {
    if (!environment.production) {

      console.log('this.authGuardService.currentUser', this.authGuardService.currentUser);
    }


    if (!this.authGuardService.isLoggedIn() ||
      this.languageDetectedFrom == "USER" ||
      this.authGuardService.currentUser.languageCode == this.language) {
      return
    }
    var res = await this.accountService.changeLanguage(this.language);
    this.authGuardService.setUserToken(res.result, false);
  }

}
